import React from 'react';
import { LessonExercise } from '../../../student/mockLessonContent';
import ChooseNextExerciseCard from './ChooseNextExerciseCard';
import ConversationExerciseCard from './ConversationExerciseCard';
import ImageExerciseCard from './ImageExerciseCard';
import ImageSelectSpeakExerciseCard from './ImageSelectSpeakExerciseCard';
import ListenRepeatExerciseCard from './ListenRepeatExerciseCard';
import MatchGameExerciseCard from './MatchGameExerciseCard';
import QuizExerciseCard from './QuizExerciseCard';
import QuizWordExerciseCard from './QuizWordExerciseCard';
import SpeakingExerciseCard from './SpeakingExerciseCard';
import SummaryExerciseCard from './SummaryExerciseCard';
import TypeSpeakExerciseCard from './TypeSpeakExerciseCard';
import WordIntroExerciseCard from './WordIntroExerciseCard';
import { ExerciseLayout, ExerciseLayoutContext } from './exerciseLayout';

const exerciseNames: Record<LessonExercise['kind'], string> = {
    image: 'Lesson introduction',
    word: 'New word',
    listenRepeat: 'Listen and repeat',
    quiz: 'Quick check',
    quizWord: 'Character check',
    match: 'Matching game',
    imageSelectSpeak: 'Choose and speak',
    typeSpeak: 'Type and speak',
    speak: 'Speaking practice',
    conversation: 'Conversation practice',
    summary: 'Speaking summary',
    chooseNext: 'Choose what is next',
};

// Kept beside the shared renderer so mobile and desktop cannot diverge on
// which exercise types need a response before Continue is enabled.
export function defaultReadyFor(exercise: LessonExercise | undefined): boolean {
    if (exercise == null) {
        return true;
    }
    if (exercise.kind === 'conversation') {
        return exercise.mode === 'listen' || exercise.mode === 'listenNoCharacters';
    }
    return exercise.kind === 'word' || exercise.kind === 'image' || exercise.kind === 'summary';
}

export function exerciseName(exercise: LessonExercise): string {
    return exerciseNames[exercise.kind];
}

export function renderLessonExercise(exercise: LessonExercise, onReady: () => void, layout: ExerciseLayout = 'mobile'): React.ReactNode {
    let card: React.ReactNode = null;
    switch (exercise.kind) {
        case 'image':
            card = <ImageExerciseCard exercise={exercise} />;
            break;
        case 'word':
            card = <WordIntroExerciseCard exercise={exercise} />;
            break;
        case 'listenRepeat':
            card = <ListenRepeatExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'quiz':
            card = <QuizExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'quizWord':
            card = <QuizWordExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'match':
            card = <MatchGameExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'imageSelectSpeak':
            card = <ImageSelectSpeakExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'typeSpeak':
            card = <TypeSpeakExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'speak':
            card = <SpeakingExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'conversation':
            card = <ConversationExerciseCard exercise={exercise} onReady={onReady} />;
            break;
        case 'summary':
            card = <SummaryExerciseCard exercise={exercise} />;
            break;
        case 'chooseNext':
            card = <ChooseNextExerciseCard exercise={exercise} onReady={onReady} />;
            break;
    }
    return <ExerciseLayoutContext.Provider value={layout}>{card}</ExerciseLayoutContext.Provider>;
}
